import React from 'react'

export default function BasicData() {
    return (
        <div className="right_col" role="main">
            Basic Data
        </div>
    )
}
